import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const footerSections = [
    {
      title: 'Buy',
      links: [
        { name: 'Buy a Business', href: '/buy-business' },
        { name: 'Buy a Franchise', href: '/buy-franchise' },
        { name: 'Buy a Franchise Resale', href: '/buy-franchise-resale' },
        { name: 'Become a Premium Buyer', href: '/premium-buyer' },
        { name: 'Email Alerts', href: '/email-alerts' },
      ]
    },
    {
      title: 'Sell',
      links: [
        { name: 'Create a Listing', href: '/create-listing' },
        { name: 'Franchisor Sign Up', href: '/franchisor-signup' },
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'All Guides', href: '/guides' },
        { name: 'Business Articles', href: '/business-articles' },
        { name: 'Franchise Articles', href: '/franchise-articles' },
      ]
    },
    {
      title: 'Services',
      links: [
        { name: 'M&A Vault', href: '/ma-vault' },
        { name: 'ValueRight', href: '/valueright' },
      ]
    },
    {
      title: 'Helpful Links',
      links: [
        { name: 'Help & FAQs', href: '/help' },
        { name: 'Staying Safe', href: '/staying-safe' },
        { name: 'Contact Us', href: '/contact' },
      ]
    }
  ];

  return (
    <footer className="bg-dark-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 sm:gap-8">
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="text-lg font-semibold mb-4 text-white">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 sm:mt-12 pt-6 sm:pt-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Left - Logo and Social */}
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <img 
                  src="/assets/images/bbm-logo-white.png" 
                  alt="BizBuyMax Logo" 
                  style={{ height: '3.75rem' }}
                  className="w-auto"
                />
                <span className="text-sm text-gray-300">BizBuyMax.com</span>
              </div>
              
                             <div className="flex space-x-4">
                 <button className="text-gray-400 hover:text-white transition-colors">
                   <span className="sr-only">X (Twitter)</span>
                   <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                     <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                   </svg>
                 </button>
                 <button className="text-gray-400 hover:text-white transition-colors">
                   <span className="sr-only">LinkedIn</span>
                   <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                     <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                   </svg>
                 </button>
                 <button className="text-gray-400 hover:text-white transition-colors">
                   <span className="sr-only">Facebook</span>
                   <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                     <path fillRule="evenodd" d="M20 10C20 4.477 15.523 0 10 0S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" />
                   </svg>
                 </button>
                 <button className="text-gray-400 hover:text-white transition-colors">
                   <span className="sr-only">RSS</span>
                   <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                     <path d="M5 3a1 1 0 000 2c5.523 0 10 4.477 10 10a1 1 0 102 0C17 8.373 11.627 3 5 3z" />
                     <path d="M4 9a1 1 0 011-1 7 7 0 017 7 1 1 0 11-2 0 5 5 0 00-5-5 1 1 0 01-1-1z" />
                     <path d="M3 15a2 2 0 114 0 2 2 0 01-4 0z" />
                   </svg>
                 </button>
               </div>
              
              <p className="text-xs text-gray-400">
                &copy; 2025
              </p>
            </div>

            {/* Middle - About Us */}
            <div>
              <h4 className="text-lg font-semibold mb-4">About Us</h4>
              <p className="text-sm text-gray-300 leading-relaxed">
                An international business advertising platform connecting buyers and sellers of businesses, franchises, and business opportunities worldwide.
              </p>
            </div>

            {/* Right - Network and Marketing */}
            <div className="space-y-6">
                             <div>
                 <h4 className="text-lg font-semibold mb-4">Network</h4>
                 <ul className="space-y-2">
                   <li>
                     <button className="text-gray-300 hover:text-white transition-colors text-sm">
                       BizBrokerMax.ca
                     </button>
                   </li>
                 </ul>
               </div>
{/*                
               <div>
                 <h4 className="text-lg font-semibold mb-4">Marketing</h4>
                 <ul className="space-y-2">
                   <li>
                     <button className="text-gray-300 hover:text-white transition-colors text-sm">
                       Partner Programme
                     </button>
                   </li>
                 </ul>
               </div> */}
            </div>
          </div>

                     {/* Bottom Links */}
           <div className="border-t border-gray-700 mt-8 pt-6">
             <div className="flex flex-wrap justify-center space-x-6 text-sm">
               <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">
                 Terms of Service
               </Link>
               <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                 Privacy Policy
               </Link>
             </div>
           </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 